<template>
  <el-dialog v-model="dialogVisible" :title="$str.getKey('策略控制/权限校验')" width="650px" append-to-body :show-close="true" :close-on-click-modal="false"
    :close-on-press-escape="false" @close="handleCancel">
    <div class="auth-dialog-content">
      <div class="auth-left">
        <div class="phone-verify" v-if="isAuth">
          <div class="phone-input">
            <span class="label">{{ $str.getKey('策略控制/手机号：') + props.phoneNumber }}</span>
          </div>
          <div class="code-input">
            <span class="label">{{ $str.getKey('策略控制/验证码：') }}</span>
            <el-input v-model="verificationCode" :placeholder="$str.getKey('策略控制/请输入验证码')" class="code-field" type="text" maxlength="4"
              oninput="value=value.replace(/[^\d]/g,'')" style="width: 120px;" />
            <el-button type="primary" @click="sendVerificationCode" :disabled="cooldownTime > 0" class="send-btn">
              {{ cooldownTime > 0 ? `${cooldownTime}s` : $str.getKey('策略控制/发送验证码') }}
            </el-button>
          </div>
        </div>
        <div class="auth-text" v-if="isAuth">
          <div class="auth-item">{{ $str.getKey('策略控制/1. 操作前提：您已持有西安奇点能源股份公司签发的回执函,可通过指定的电站管理员手机号完成验证后进行操作。') }}</div>
          <div class="auth-item">{{ $str.getKey('策略控制/2. 风险提示：此模块涉及高风险操作，可能影响电站设备工作模式、需量、逆流等系统参数，请确认您具备相关调度经验，并能够合理评估操作的影响范围。') }}</div>
          <div class="auth-item">{{ $str.getKey('策略控制/3. 确认要求：请再次确认操作内容，确保安全合规，避免对设备造成不利影响。') }}</div>
          <div class="auth-item">{{ $str.getKey('策略控制/如需进一步协助，请联系西安奇点能源股份公司运维团队！') }}</div>
        </div>
        <div class="auth-text" v-else>
          <div class="auth-item">{{ $str.getKey('策略控制/您未持有西安奇点能源股份公司签发的回执函,无此功能操作权限！') }}</div>
          <div class="auth-item">{{ $str.getKey('策略控制/请联系奇点能源售后运维团队进行相关授权操作！') }}</div>
        </div>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleCancel" v-if="isAuth">{{ $str.getKey('策略控制/取消') }}</el-button>
        <el-button type="primary" @click="handleConfirm" v-if="isAuth">{{ $str.getKey('策略控制/确认') }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, watch, onBeforeUnmount } from 'vue'
import { ElMessage } from 'element-plus'
import * as strategyApi from '../api.js'

const $str = window.$str;

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  stationId: {
    type: String,
    default: ''
  },
  isAuth: {
    type: Boolean,
    default: false
  },
  phoneNumber:{
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:visible', 'cancel', 'confirm'])

// 内部状态
const dialogVisible = ref(false)
const verificationCode = ref('')
const cooldownTime = ref(0)
let timer = null

// 同步visible和dialogVisible
watch(() => props.visible, (newVal) => {

  dialogVisible.value = newVal
  if (newVal) {
    cooldownTime.value = 0;
    // 弹窗打开时初始化数据
    verificationCode.value = ''
  }


})

watch(() => dialogVisible.value, (newVal) => {
  emit('update:visible', newVal)
})


// 发送验证码
async function sendVerificationCode() {
  // 调用实际的API发送验证码
  // 这里假设有一个用于发送验证码的API
  // 如果没有具体API，请替换成实际项目中的API调用
  let res = await strategyApi.getSmsCode(props.phoneNumber)
  if (res.code == 200) {
    ElMessage.success($str.getKey('策略控制/验证码发送成功'))
    startCountdown()
  } else {
    ElMessage.error($str.getKey('策略控制/验证码发送失败: ') + (res.message || $str.getKey('策略控制/未知错误')))
  }
}

// 倒计时
function startCountdown() {
  cooldownTime.value = 60 * 5
  clearInterval(timer)
  timer = setInterval(() => {
    cooldownTime.value--
    if (cooldownTime.value <= 0) {
      clearInterval(timer)
    }
  }, 1000)
}

// 取消
function handleCancel() {
  cooldownTime.value = 0;
  clearInterval(timer)
  emit('cancel')
  emit('update:visible', false)
}

const timeData = ref(0)
// 确认
function handleConfirm() {

  timeData.value = JSON.stringify(cooldownTime.value)
  if (verificationCode.value == '') {
    ElMessage.warning($str.getKey('策略控制/请输入验证码'))
    return
  }


  strategyApi.checkSmsCodeSilent({
    phoneNumber: props.phoneNumber,
    smsCode: verificationCode.value
  }).then(res => {
    if (res.code == 200) {

      // 发射确认事件，传递验证码
      emit('confirm', verificationCode.value)
      setTimeout(() => {
       cooldownTime.value = 0;
      }, 1500)
      
    } else {
      ElMessage.error($str.getKey('策略控制/验证码校验失败'))
    }
  })



  // 注意：不在这里关闭弹窗，由父组件决定是否关闭

  // 这允许在验证失败时保持弹窗开启状态
}

// 组件销毁时清理定时器
onBeforeUnmount(() => {
  clearInterval(timer)
  cooldownTime.value = 0;
})
</script>

<style lang="scss" scoped>                      
.auth-dialog-content {
  display: flex;
  border-radius: 8px;
  padding: 20px 30px;

  .auth-left {
    flex: 1;

    .phone-verify {
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid rgba(151, 160, 183, 0.2);

      .phone-input {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        .label {
          color: #2E2E2E;
          margin-right: 10px;
          min-width: 60px;
          line-height: 32px;
        }

        .value {
          color: #2E2E2E;
          font-weight: 500;
        }
      }

      .code-input {
        display: flex;
        margin-bottom: 15px;
        .label{
          line-height: 32px;
        }

        .code-field {
          flex: 0.4;
          margin-right: 10px;

          :deep(.el-input__inner) {
            border-color: #3A4157;
            color: #2E2E2E;
            padding-left: 6px;
          }

          :deep(.el-input__wrapper) {
            padding: 1px;
          }

        }

        .send-btn {
          min-width: 120px;
          color: #FFFFFF;
        }
      }
    }
  }

  .auth-text {
    flex: 1;

    .auth-item {
      font-size: 14px;
      color: #2E2E2E;
      line-height: 1.8;
      margin-bottom: 10px;
      text-align: left;

      &:last-child {
        margin-top: 20px;
        color: #97A0B7;
        font-style: italic;
      }
    }
  }
}

// 修改element-plus弹窗样式（浅色，跟随系统默认弹框风格）
:deep(.el-dialog) {
  background-color: #ffffff;

  .el-dialog__header {
    margin: 0;
    padding: 15px 20px;
    background-color: #ffffff;

    .el-dialog__title {
      color: #2E2E2E;
      font-size: 16px;
      font-weight: bold;
    }
  }

  .el-dialog__body {
    padding: 20px;
    color: #2E2E2E;
  }

  .el-dialog__footer {
    padding: 10px 20px 20px;
  }
}
</style>